





























































































import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { Validations } from 'vuelidate-property-decorators'
import { reactive } from '@vue/composition-api'
import {
  getContactFormHeardAboutUsReasonsAsync,
  saveUsersRequestForMoreInformationAboutMultipleLotsAsync,
} from '~/api/map.api'
import { saveUsersRequestForMoreInformationAboutLotAsync } from '~/api/consumer_map.api'
import { uiStore } from '~/store'
import { LotInfo, CustomQueryParam, Realtor, Employer } from '~/models'
import { Events } from '~/utils/eventLayers'
import Input from '~/components/shared/inputs/Input.vue'
import { LotTypes } from '~/enums/lots'
import defaultFormDefinition from '~/assets/leadCaptureForm/default.json'
import { DynamicForm } from '~/models/forms'
import debounce from '~/utils/debounce'
import { getLookupOptions } from '~/api/lookups.api'
import { getRealtor } from '~/api/realtor.api'

@Component({
  components: {
    Input,
  },
  computed: {
    ...mapGetters('consumer-map', {
      queryParams: 'queryParams',
    }),
  },
})
export default class ContactForm extends Vue {
  queryParams: CustomQueryParam

  @Prop({ default: () => {} }) lot: LotInfo
  @Prop({ default: (): Array<LotInfo> => [] }) lots: Array<LotInfo>
  @Prop({ default: undefined }) customContactFormFields: any | undefined | null
  @Prop({ default: null }) planSelected: any
  @Prop({ default: null }) elevationSelected: any

  isSubmitted: boolean = false
  resizeWindowListener: any = null
  viewHeight: number = 400

  formDefinition: any = {}
  contactForm: any = null
  validators: any = null
  v$: any = null
  form: any = null
  attemptToSave: boolean = false
  loadLookupOptionsDebounced: Function
  dynamicFormInstance: any = null
  realtor: Realtor = null

  async onRealtorIdChange(value: number) {
    let first_name = ''
    let last_name = ''
    let phone = ''
    let email = ''

    if (value) {
      const realtor = await getRealtor(value)
      this.realtor = realtor
      first_name = realtor.first_name
      last_name = realtor.last_name
      phone = realtor.phone
      email = realtor.email
    } else {
      this.realtor = null
    }

    this.dynamicFormInstance.updateFieldValueModel(
      this.contactForm,
      'first_name',
      first_name
    )
    this.dynamicFormInstance.updateFieldValueModel(
      this.contactForm,
      'last_name',
      last_name
    )

    this.dynamicFormInstance.updateFieldValueModel(
      this.contactForm,
      'phone',
      phone
    )

    this.dynamicFormInstance.updateFieldValueModel(
      this.contactForm,
      'email',
      email
    )
  }

  async loadLookupOptions(search: string, control: any): Promise<void> {
    try {
      const { lookup } = control.settings
      let lookupOptions: Array<Employer | Realtor> = []
      if (lookup && search) {
        lookupOptions = await getLookupOptions(search, lookup)

        control.settings = {
          ...control.settings,
          options: [...lookupOptions],
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  async created() {
    // We load the form definition from the file if it exists, otherwise we load it from the DB.
    // If the file doesn't exist, and there's no custom form in the db, we use the default form.
    const clientFormDefinitionFromFile = this.getFormDefinitionFromFile()
    const clientFormDefinitionFromDB = this.getCustomFormDefinitionFromDB()
    let clientForm: any = null
    if (clientFormDefinitionFromFile && !clientFormDefinitionFromDB) {
      clientForm = { ...clientFormDefinitionFromFile }
    }

    if (clientFormDefinitionFromDB) {
      clientForm = { ...clientFormDefinitionFromDB }
    }

    if (!clientFormDefinitionFromFile && !clientFormDefinitionFromDB) {
      clientForm = defaultFormDefinition
    }
    const updatedForm = await this.setupFormHeardAboutUs(clientForm.form)
    this.formDefinition = {
      ...clientForm,
      form: updatedForm ? [...updatedForm] : [...clientForm.form],
    }
    this.setupForm(this.formDefinition.form)
  }

  @Watch('contactForm.realtor', { deep: true })
  onRealtorChange(value: number): void {
    this.onRealtorIdChange(value)
  }

  getFormDefinitionFromFile() {
    let formDefinition = null
    try {
      formDefinition = require(`~/assets/leadCaptureForm/${this.$route.params.slug}.json`)
    } catch (error) {
      formDefinition = require(`~/assets/leadCaptureForm/default.json`)
    }
    return formDefinition
  }

  getCustomFormDefinitionFromDB() {
    const fields = this.customContactFormFields
    if (!fields || Object.keys(fields).length === 0) {
      return null
    }
    return this.customContactFormFields
  }

  setupForm(metadata: any): void {
    const form = new DynamicForm(metadata, this, 'contactForm')
    this.contactForm = reactive(form.model)
    this.validators = form.validators
    this.updateValidatorInstance(this.validators)
    this.form = form.steps
    this.dynamicFormInstance = form
  }

  async setupFormHeardAboutUs(form: any): Promise<any> {
    const heardAboutUsSelectIndex = form.findIndex(
      (x: any) => x.id === 'heard_about_us_reason'
    )
    if (!form[heardAboutUsSelectIndex]?.settings?.options) {
      // @ts-ignore
      form[heardAboutUsSelectIndex]?.settings?.options = []
      return form
    }

    const reasons = await getContactFormHeardAboutUsReasonsAsync()
    const finalform = [...form]
    if (reasons.length) {
      finalform[heardAboutUsSelectIndex].settings.options = reasons
    }
    return finalform
  }

  updateValidatorInstance(validators: any = null) {
    if (validators) {
      this.v$ = useVuelidate({ ...validators }, this.contactForm)
    }
  }

  @Validations()
  validations() {
    if (this.validators) {
      return this.validators
    }
    return {}
  }

  mounted() {
    this.resizeWindowListener = window.addEventListener(
      'resize',
      this.setWindowSize
    )
    this.setWindowSize()
    this.loadLookupOptionsDebounced = debounce(this.loadLookupOptions, 500)
  }

  unmounted(): void {
    window.removeEventListener('resize', this.resizeWindowListener)
  }

  setWindowSize() {
    if (window.visualViewport) {
      this.viewHeight = window.visualViewport.height - 90
    } else {
      this.viewHeight = window.innerHeight - 90
    }
  }

  submitForm() {
    this.attemptToSave = true
    uiStore.updateLoding(true)
    if (this.isMultipleLotSubmission()) {
      this.saveMultipleLotsAsync(this.contactForm)
    } else {
      this.saveSingleLotAsync(this.contactForm)
    }
  }

  async saveMultipleLotsAsync(form: any) {
    try {
      await saveUsersRequestForMoreInformationAboutMultipleLotsAsync(
        this.makeSubmitObject(form)
      )

      this.lots.forEach((lot) => {
        const category: string =
          lot.type === LotTypes.HOME_SITE ? 'homesite' : 'home'
        Events.submitRequestInfo(
          'mapFormSubmit',
          category,
          'submit | request information',
          'map',
          lot?.builder.name,
          lot
        )
      })
    } catch (err) {
      console.log('Error submitting', err)
    } finally {
      this.isSubmitted = true
      uiStore.updateLoding(false)
    }
  }

  async saveSingleLotAsync(form: any) {
    try {
      await saveUsersRequestForMoreInformationAboutLotAsync(
        this.lot?.slug ||
          this.elevationSelected?.slug ||
          this.planSelected?.slug,
        this.makeSubmitObject(form)
      )

      let category: string
      if (this.lot) {
        category = this.lot.type === LotTypes.HOME_SITE ? 'homesite' : 'home'
      }

      Events.submitRequestInfo(
        'mapFormSubmit',
        category,
        'submit | request information',
        'map',
        this.lot?.builder?.name || this.planSelected?.builder?.name,
        this.lot || this.elevationSelected || this.planSelected
      )
    } catch (err) {
      console.log('Error submitting', err)
    } finally {
      this.isSubmitted = true
      uiStore.updateLoding(false)
    }
  }

  makeSubmitObject(form: any) {
    return {
      isRealtor: form.isRealtor,
      first_name: form.first_name,
      last_name: form.last_name,
      phone: form.phone,
      email: form.email,
      comments: form.comments,
      lots: this.lots,
      query_params: this.queryParams,
      zipcode: form.zipcode,
      heard_about_us_reason: form.heard_about_us_reason,
      interested_in: form.interested_in,
      price_range: form.price_range,
      preferred_move_in_date: form.preferred_move_in_date,
      preferred_bedrooms: form.preferred_bedrooms,
      preferred_bathrooms: form.preferred_bathrooms,
      additional_requirements: form.additional_requirements,
      preferred_contact_method: form.preferred_contact_method,
    }
  }

  isMultipleLotSubmission() {
    return this.lots && this.lots.length > 1
  }

  handleReset() {
    Object.keys(this.contactForm).forEach((key) => {
      this.contactForm[key] = ''
    })
  }

  isDisabled() {
    return this.v$?.value?.$invalid
  }

  displayError(inputId: string) {
    const { $dirty, $invalid, $errors } = this.v$.value[inputId]
    if ($dirty && $invalid && $errors.length) {
      return $errors[0].$message
    }
  }

  onFindRealtor(value: any, input: any): void {
    const isRealtor: any = this.contactForm.isRealtor
    const isRealtorOnly: boolean =
      input.settings && input.settings.isRealtorOnly

    if (isRealtor && isRealtorOnly) {
      this.loadLookupOptionsDebounced(value, input)
    }
  }
}
